import React, { useLayoutEffect, useState } from 'react';

import * as S from './styles';
import { ItemDynamicPageInPhone } from 'types/ItemDynamicPageInPhone';
import WaitingForDataDynamicPage from 'components/WaitingForDataDynamicPage';
import { DataFormCarroselBannersProps } from 'types/DataFormCarroselBannersProps';
import { CarouselImagesWithDescription } from 'types/CarouselImagesWithDescription';
import { png } from 'utils/imgList';
import CarouselBannersWithDescription from 'components/CarouselBannersWithDescription';
interface CarrosselBannersProps {
	item: ItemDynamicPageInPhone;
}

export default function CarrosselBanners({ item }: CarrosselBannersProps) {
	const { data } = item;
	const bannersData: DataFormCarroselBannersProps = data;

	const [arrayIms, setArrayImgs] = useState<CarouselImagesWithDescription[]>(
		[]
	);

	useLayoutEffect(() => {
		if (
			Object.keys(bannersData).length > 0 &&
			bannersData?.banners.length > 0
		) {
			const listOfImgs: CarouselImagesWithDescription[] =
				bannersData.banners.map((banner, i) => ({
					id: banner?.image?.id || i,
					imageUrl: banner?.image?.relativePath || png.genericImage,
					title: banner?.description?.title || '',
					subtitle: banner?.description?.subTitle || '',
					description: banner?.description?.descriptionText || ''
				}));
			setArrayImgs(listOfImgs);
		}
	}, [bannersData]);

	return Object.keys(bannersData).length === 0 ? (
		<WaitingForDataDynamicPage />
	) : (
		<S.container>
			<CarouselBannersWithDescription
				isAutoPlay={true}
				items={arrayIms}
				showClicks={false}
				isBtns={false}
			/>
		</S.container>
	);
}
